import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-579bc9a2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-content w-100 d-flex flex-col align-items-center" }
const _hoisted_2 = { class: "d-flex flex-row justify-content-end m-r-16 m-b-16" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Download ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ModalHeader = _resolveComponent("ModalHeader")!
  const _component_document_preview = _resolveComponent("document-preview")!
  const _component_SmallButton = _resolveComponent("SmallButton")!
  const _component_page_wrapper = _resolveComponent("page-wrapper")!

  return (_openBlock(), _createBlock(_component_page_wrapper, { contentWidthFull: "" }, {
    "content-header": _withCtx(() => [
      _createVNode(_component_ModalHeader, {
        "header-text": _ctx.document.name,
        headerIcon: "icon-attachments"
      }, null, 8, ["header-text"])
    ]),
    "content-top": _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_document_preview, {
          document: _ctx.document,
          class: "w-max-100 h-max-100"
        }, null, 8, ["document"])
      ])
    ]),
    "content-footer": _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_SmallButton, {
          onClick: _ctx.downloadDocument,
          color: _ctx.ButtonColor.PRIMARY,
          pattern: _ctx.ButtonColorPattern.FILL
        }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        }, 8, ["onClick", "color", "pattern"])
      ])
    ]),
    _: 1
  }))
}